module.exports = __webpack_public_path__ + "img/sponsor-daphne-logo.f0ac74b0.jpg";